import PageComponent from '../../base/PageComponent';
import "bootstrap-3-typeahead";
import 'selectize';

/**
 * A component for managing the patient fields in a form, looks up the patient using their NHI
 */
export default class ConsultantFields extends PageComponent
{
    init() {
        // field for consultant to select themselves or another consultant
        this.consultantSelector = 'input[name="ConsultantIsResponsible"]';

        this.extraResponsibleFields = $(`<div class="row" />`).appendTo(this.element);

        this.consultantSelectize = this.childElements('[name="ConsultantID"]').selectize({
            valueField: 'ID',
            labelField: 'Name',
            searchField: ['Name', 'FirstName', 'Surname', 'DistrictHealthBoard', 'ClinicalSpeciality'],
            maxItems: 1,
            create: false,
            render: {
                option: function(item, escape) {
                    return `
<div class="consultant-lookup">
    <span class="name">${escape(item.Name)}</span>
    <span class="speciality">${escape(item.ClinicalSpeciality)},</span>
    <span class="dhb">${escape(item.DistrictHealthBoard)}</span>
</div>
                    `;
                },
            },
            onChange: this.displayResponsibleConsultantFields.bind(this),
            load: this.loadResults.bind(this),
            preload: 'focus'
        })[0].selectize;

        this.displayResponsibleConsultantFields();

        this.bindEvents();
        this.toggleAnotherConsultantFields();
    }

    /**
     * Set the url to be used for lookup requests.
     *
     * @param {string} url The url to use.
     * @returns {ConsultantFields}
     */
    setLookupUrl(url) {
        this.lookupUrl = url;
        return this;
    }

    bindEvents() {
        // consultant
        this.element.on('change', this.consultantSelector, this.toggleAnotherConsultantFields.bind(this));
        this.element.on('change', '[name="ClinicalSpecialityID"],[name="DistrictHealthBoardID"]', this.clearSelection.bind(this));
    }

    loadResults(query, callback) {
        const data = {'query': query}

        const specialty = this.childrenByName('ClinicalSpecialityID').val();
        if (specialty) {
            data['ClinicalSpecialityID'] = specialty;
        }

        const dhb = this.childrenByName('DistrictHealthBoardID').val();
        if (dhb) {
            data['DistrictHealthBoardID'] = dhb;
        }

        $.ajax({
            url: this.lookupUrl,
            type: 'GET',
            dataType: 'json',
            data: data,
            error: callback,
            success: callback
        });
    }

    /**
     * Show fields for consultant if the requesting consultant isn't responsible for patient
     */
    toggleAnotherConsultantFields() {
        let selectedField = this.childElements(this.consultantSelector).filter(':checked');

        // if there is no selected field, then do nothing (likely field isn't present
        if (!selectedField.length) return;

        let val = selectedField.val(),
            consultantFields = this.childElements('#ConsultantID, #ClinicalSpecialityID, #DistrictHealthBoardID');

        if (val === "0") {
            consultantFields.show();
        } else {
            consultantFields.hide();
        }
    }

    clearSelection() {
        this.consultantSelectize.clear();
        this.consultantSelectize.clearOptions();
        this.consultantSelectize.focus();
    }

    hide() {
        this.element.hide();
    }

    show() {
        this.element.show();
    }

    /**
     * Display some extra fields when the responsible consultant changes
     */
    displayResponsibleConsultantFields() {
        this.extraResponsibleFields.find('*').remove();
        if (this.consultantSelectize.items.length == 0) {
            return;
        }


        const value = this.consultantSelectize.items[0];
        const item = this.consultantSelectize.options[value];


        if (typeof item != 'undefined') {
            this.addFakeField('Email', item.Email);
            this.addFakeField('Mobile Number', item.MobileNumber);
            this.addFakeField('MCNZ/NCNZ Number', item.MCNZNumber);
            this.addFakeField('DHB', item.DistrictHealthBoard);
        }
    }

    /**
     * Utility function adding the extra responsible consultant field.
     * @param string labelText
     * @param string value
     */
    addFakeField(labelText, value) {
        const label = $('<label/>').text(labelText);
        const input = $('<input type="text" class="text form-control" disabled="disabled" readonly="readonly" />')
            .val(value);
        const formGroup = $('<div class="form-group col-sm-6" />').append(label).append(input);

        this.extraResponsibleFields.append(formGroup);
    }
}
